import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-5 mx-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-weight-500 text-center text-weight-600" }, [
  /*#__PURE__*/_createTextVNode("\n        ご登録された電話番号宛(SMS)に、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n        再設定用の認証コードが送信されます\n      ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      パスワード再設定\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(),
      _createVNode(_component_AppButton, {
        block: "",
        rounded: "",
        onClick: _ctx.nextStep
      }, {
        default: _withCtx(() => [
          _createTextVNode("\n        認証コードを送信する\n      ")
        ], undefined, true),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}